import { updateTimer } from "@/models/timers.model";
import { AppContext } from "@/services/AppContext/appContext";
import { OrganizedTimersEvent } from "@/types";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils";
import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useCallback,
  useContext,
  useRef,
} from "react";

const useHandleSave = (
  editedTimer: OrganizedTimersEvent | null,
  saveAllowed: MutableRefObject<boolean>,
  editedTimerRef: MutableRefObject<OrganizedTimersEvent | null>,
  setIsEditing: Dispatch<SetStateAction<boolean>>,
  setSelectedEditableTimer: Dispatch<
    SetStateAction<OrganizedTimersEvent | null>
  >
) => {
  const { initialGetUserTimers, user, fetchPageTimers, fetchEveryoneTimers } =
    useContext(AppContext);
  const controllerRef = useRef(new AbortController());
  const handleSave = useCallback(async () => {
    if (!editedTimer) return;
    setSelectedEditableTimer(editedTimer);
    setIsEditing(false);

    const controller = new AbortController();
    controllerRef.current = controller;
    const signal = controller.signal;

    const res = await updateTimer({ timer: editedTimer });
    if (res.rStatus === "success") {
      // Visually update the Timer, in the event subsequent call is too quick
      console.log("Timer updated successfully");
      genericSuccessToast("Timer updated successfully");
      await initialGetUserTimers(user.id, true);
      await fetchPageTimers(signal, fetchEveryoneTimers);
    } else {
      genericFailureToast("Failed to update task");
      setSelectedEditableTimer(null);
    }

    saveAllowed.current = false;
    editedTimerRef.current = null;
    setIsEditing(false);
  }, [
    editedTimer,
    setSelectedEditableTimer,
    setIsEditing,
    saveAllowed,
    editedTimerRef,
    initialGetUserTimers,
    user,
    fetchEveryoneTimers,
    fetchPageTimers,
  ]);

  return { handleSave };
};

export default useHandleSave;
